import React from "react";
import { useTheme } from "@emotion/react";
import classNames from "classnames";
import styles from "./StatusBadge.module.scss";
// variant is based on font size
export var StatusBadgeVariant;
(function (StatusBadgeVariant) {
    StatusBadgeVariant["LARGE"] = "LARGE";
    StatusBadgeVariant["MEDIUM"] = "MEDIUM";
    StatusBadgeVariant["SMALL"] = "SMALL";
})(StatusBadgeVariant || (StatusBadgeVariant = {}));
export const StatusBadge = (props) => {
    const theme = useTheme();
    return (React.createElement("div", { className: classNames(styles.Container, {
            [styles.Large]: props.variant == StatusBadgeVariant.LARGE,
            [styles.Medium]: props.variant == StatusBadgeVariant.MEDIUM,
            [styles.Small]: props.variant == StatusBadgeVariant.SMALL,
        }) },
        props.icon && props.variant == StatusBadgeVariant.SMALL && (React.createElement(props.icon, { size: 16, color: theme.colors.light.on_primary })),
        React.createElement("span", null, props.text)));
};
//# sourceMappingURL=StatusBadge.js.map